import { setFontValue } from '@vedalib/editor/lib/brand'

import { Tooltip } from 'components/uiKit/Dropdown'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ISelectOption } from 'components/uiKit/Select'
import type { FontGroupFullSchemaFragment } from 'gql/__generated__/graphql'
import { t } from 'services/Translation'

import { FONT_WEIGHT_OPTIONS, validateFontFamilyCss } from '.'
import * as s from './Styles.module.scss'

export const createFontWeightOptions = (
  font: { name?: string } | null,
  fontGroup?: FontGroupFullSchemaFragment,
  fontStyle?: string,
) =>
  FONT_WEIGHT_OPTIONS.map((option) => {
    const isFont = fontGroup
      ? fontGroup.fonts.some((font) => font.weight === option.value || !font.weight)
      : true
    return {
      ...option,
      label: (
        <div
          style={{
            fontFamily: validateFontFamilyCss(setFontValue(fontGroup || font || { name: 'Inter' })),
            fontWeight: option.value,
            fontStyle,
          }}
        >
          <Tooltip overlay={!isFont ? t('uiKit.tooltip.syntheticFont') : null} placement='left'>
            {typeof option?.label !== 'function' ? option.label : option.label({})}
            {!isFont && '*'}
          </Tooltip>
        </div>
      ),
    }
  })

const genFontOption = (name: string): ISelectOption<string> => ({
  value: setFontValue({ name }),
  label: <div style={{ fontFamily: validateFontFamilyCss(setFontValue({ name })) }}>{name}</div>,
  textLabel: name,
  searchable: name,
})

export const FONT_FAMILY_OPTIONS = [
  genFontOption('Inter'),
  genFontOption('Arial'),
  genFontOption('Verdana'),
  genFontOption('Helvetica'),
  genFontOption('Tahoma'),
  genFontOption('Trebuchet MS'),
  genFontOption('Times New Roman'),
  genFontOption('Georgia'),
  genFontOption('Garamond'),
  genFontOption('Courier New'),
  genFontOption('Montserrat'),
  genFontOption('Brush Script MT'),
]

export const createFontFamilyOption = (
  fontGroup: FontGroupFullSchemaFragment,
): ISelectOption<string> => ({
  value: setFontValue(fontGroup),
  textLabel: fontGroup.name,
  searchable: fontGroup.name,
  label: (
    <div
      className={s.fontFamily}
      style={{ fontFamily: validateFontFamilyCss(setFontValue(fontGroup)) }}
    >
      {fontGroup.isArchived && (
        <Tooltip overlay={t('uiKit.tooltip.fontArchived')} placement='top-start'>
          <Icon name='missingFont' size={KitSize.S} />
        </Tooltip>
      )}
      {fontGroup.name}
    </div>
  ),
})
